
     var allTheFishes = []

var plusOrMinus = function(n) {
  var theOperator = Math.random() < 0.5 ? -1 : 1;
  return theOperator * n
}

     var fishMaker = function (fishKind, fishShape, fishNumber) {
       for (var i = 0; i < fishNumber; i++) {
         var randomSpeed = Math.floor(Math.random() * 100000) + 5000
         var theString =  fishKind === 'still' ? '400000': randomSpeed.toString();

         var theDirection = '-360'
         if (fishKind === 'left') {
           theDirection = '360'
         }
         if (fishKind === 'still') {
            theDirection = plusOrMinus(360).toString()
         }
         var theAnimation = fishKind === 'still' ? '' : 'property: rotation; dur: ' + theString + '; pauseEvents: nowPause; resumeEvents: nowResume; startEvents: nowGo; easing: linear; loop: true; to: 0 ' + theDirection + ' 0'
       
         var theOpacity = fishKind === 'still' ? '0.5' : 0

         var xValue = fishKind === 'still' ? plusOrMinus(Math.random()) : plusOrMinus(Math.random() * 10)
          var yValue =  plusOrMinus(Math.random() * 8 )
          var zValue =  fishKind === 'still' ? plusOrMinus(Math.random()) : plusOrMinus((Math.random() * 10) + 2)

          var theYRotation = fishKind === 'still' ? plusOrMinus(Math.floor(Math.random() * 360)).toString() : 0
          var theRadius =  fishKind === 'still' ? (Math.random() * 7) + 8 :  7

       
         
          var theHeightBase = Math.random()* 3 + 1 

             var theTheta;
             var theHeight;
          
             if (fishShape === 'rg') {
             theHeight = theHeightBase * 2
            theTheta = theHeight*20
           }

            if (fishShape === 'th') {
              theHeight = theHeightBase * 1
            theTheta = theHeight*30
           }
            if (fishShape === 'sq') {
              theHeight = theHeightBase * 3
            theTheta = theHeight*10
           }
           if (fishShape === 'ln') {
            theHeight = theHeightBase * 4
           theTheta = theHeight*5

                     }

          var fileNumber = i + 1
          var identifier = fishKind + fishShape + fileNumber
         var fishObject = {
            blueId: 'blue' + identifier,
            paperId: 'paper' + identifier,
            blueAssetId: '#' + "blue" + identifier,
            paperAssetId: '#' + "paper" + identifier,
           blueSrc: 'static/img/blue/' + fishKind + '/' + fishShape + '/blue-' + fishKind + fishShape + fileNumber + '.jpg',
           paperSrc: 'static/img/book/' + fishKind + '/' + fishShape + '/' + fishKind + fishShape + fileNumber + '.jpg',
           fishKind: fishKind,
           number: i,
           key: fishKind + fishShape + i,
           animation: theAnimation,
           position: {
            x: xValue,
            y: yValue,
            z: zValue
           },
           rotation: "0 " + theYRotation + ' 0',
           radius: theRadius, 
           theta: theTheta,
           height: theHeight,
           opacity: theOpacity
         }
   
         allTheFishes.push(fishObject);
       
       }
     }


     fishMaker('still', 'rg', 6)
     fishMaker('still', 'sq', 3)
     // fishMaker('still', 'th', 2)
     // fishMaker('still', 'ln', 1)

     fishMaker('left', 'rg', 10)
     fishMaker('left', 'sq', 4)
     fishMaker('left', 'th', 6)
     fishMaker('left', 'ln', 1)

     fishMaker('right', 'rg', 11)
     fishMaker('right', 'sq', 2)
     fishMaker('right', 'th', 10)
     fishMaker('right', 'ln', 1)





     export default   allTheFishes 




